<div class="content-container">
  <div class="title">
    <div class="user-info-container">
      <img
        [alt]="OnChangeformatInvestorName(investment.user?.fullName)"
        [src]="investment.user?.photoAttachmentUrl || defaultProfileImage"
        class="investor-image"
      />
      <div class="investor-name-title">
        {{ OnChangeformatInvestorName(investment?.user?.fullName) || '-' }}
      </div>
      <div class="paymentstatus-container" [class]="getReviewStatusClass(investment.reviewStatus)">
        {{ 'shareAllotment.ReviewStatus.' + ReviewStatus[investment.reviewStatus] | translate }}
      </div>
    </div>
    <div>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="section-container">
    <div class="section-title">Personal Information</div>
    <div class="section-info">
      <div class="info-column">
        <div class="info-label">Name</div>
        <div class="info-value">{{ investment.user?.fullName || '-' }}</div>
      </div>
      <div class="info-column">
        <div class="info-label">Type</div>
        <div class="info-value">{{ investment.isNominee ? 'Nominee' : 'Direct Investor' }}</div>
      </div>
    </div>
  </div>
  <div class="section-container">
    <div class="section-title">Investment Information</div>
    <div class="section-info">
      <div class="info-column">
        <div class="info-label">Investment Amount</div>
        <div class="info-value">
          <span class="tw-text-impact-esg">{{ investment.pledgedAmount | numberSuffix }}</span>
        </div>
      </div>
      <div class="info-column">
        <div class="info-label">Investment Date</div>
        <div class="info-value">{{ investment.createdAt | date: 'dd-MM-yyyy' }}</div>
      </div>
      <div class="info-column">
        <div class="info-label">Payment Source</div>
        <div class="info-value">
          {{ 'investment.' + PaymentTo[investment.paymentTo] | translate }}
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="isRevised ? 'section-container-last' : 'section-container'">
    <div class="section-title">Share Information</div>
    <div class="section-info">
      <div class="info-column">
        <div class="info-label">Total Shares</div>
        <div class="info-value">
          <span class="tw-text-link"
            >{{ investment.shareQuantity + investment.bonusShareShareQuantity }} shares</span
          >
        </div>
      </div>
      <div class="info-column">
        <div class="info-label">Share Type</div>
        <div class="info-value tw-uppercase">{{ ShareType[investment.shareType] | translate }}</div>
      </div>
      <div class="info-column">
        <div class="info-label">Base Shares</div>
        <div class="info-value">{{ investment.shareQuantity }} shares</div>
      </div>
      <div class="info-column">
        <div class="info-label">Free Shares</div>
        <div class="info-value">{{ investment.bonusShareShareQuantity }} shares</div>
      </div>
    </div>
  </div>
  @if (showRequestDetails) {
    @if (!(isApproved && existingRequestExists === false && !isRemarkEditable)) {
      <div class="section-container" style="border-bottom: 0; padding-bottom: 0">
        <div class="section-title">
          {{ isLockedStatus && !isRemarkEditable ? 'Request Details' : 'Request Information Edit' }}
        </div>
        @if (!(isLockedStatus && !isRemarkEditable)) {
          <div>
            <span class="req-edit-sub"
              >Please provide details about what information needs to be corrected for
            </span>
            <span class="req-edit-sub-name">{{ investment.user?.fullName || '-' }}.</span>
          </div>
        }
        <form #reqEditForm="ngForm" (ngSubmit)="submitRequest(reqEditForm)">
          <div class="section-info">
            @if (isLockedStatus && !isRemarkEditable) {
              <div class="info-column">
                <div class="info-label">Submitted On</div>
                <div class="info-value">{{ reviewSubmittedOn | date: 'dd-MM-yyyy' }}</div>
              </div>
            }
            <div class="tw-w-full">
              <div
                class="tw-pb-2"
                [ngClass]="
                  isLockedStatus && !isRemarkEditable ? 'info-label' : 'info-label-remarks'
                "
              >
                {{ isLockedStatus && !isRemarkEditable ? 'Remarks' : 'Remark (Required)' }}
              </div>
              <textarea
                id="remark"
                name="remark"
                class="form-control"
                cdkTextareaAutosize
                #remarkAutosize="cdkTextareaAutosize"
                [cdkAutosizeMinRows]="remarkMinRows"
                [cdkAutosizeMaxRows]="12"
                required
                [attr.maxlength]="maxRemarkLength"
                [disabled]="isRemarkDisabled"
                [(ngModel)]="remark"
                (ngModelChange)="onRemarkChange($event)"
              ></textarea>
              @if (reqEditForm.submitted && !remark?.trim()) {
                <div class="tw-mt-1 tw-text-sm tw-text-primary">Remark is required</div>
              }
            </div>
          </div>
          <div class="m-btn-container tw-flex tw-justify-end tw-gap-2 tw-pt-4">
            <button
              type="button"
              class="btn cancel-btn m-full"
              (click)="cancel()"
              [disabled]="submitting"
            >
              {{ isLockedStatus && !isRemarkEditable ? 'Close' : 'Cancel' }}
            </button>
            @if (isLockedStatus) {
              @if (!isRemarkEditable) {
                <button
                  type="button"
                  class="btn btn-primary m-full"
                  (click)="enableRemarkEditing()"
                  [disabled]="submitting"
                >
                  Edit Review
                </button>
              }
              @if (isRemarkEditable) {
                <button type="submit" class="btn btn-primary m-full" [disabled]="submitting">
                  Update Review
                </button>
              }
            }
            @if (isRevised) {
              <button type="submit" class="btn btn-primary m-full" [disabled]="submitting">
                Update Review
              </button>
            }
            @if (!isLockedStatus && !isRevised) {
              <button type="submit" class="btn btn-primary m-full" [disabled]="submitting">
                {{ isEditMode ? 'Update Request' : 'Submit Request' }}
              </button>
            }
          </div>
        </form>
      </div>
    } @else {
      <div class="m-btn-container tw-flex tw-justify-end tw-gap-2 tw-pt-4">
        <button
          type="button"
          class="btn cancel-btn m-full"
          (click)="cancel()"
          [disabled]="submitting"
        >
          Close
        </button>
        @if (isLockedStatus) {
          @if (!isRemarkEditable) {
            <button
              type="button"
              class="btn btn-primary m-full"
              (click)="enableRemarkEditing()"
              [disabled]="submitting"
            >
              Edit Review
            </button>
          }
        }
      </div>
    }
  } @else {
    <div class="m-btn-container tw-flex tw-justify-end tw-gap-2 tw-pt-4">
      <button
        type="button"
        class="btn cancel-btn m-full"
        (click)="cancel()"
        [disabled]="submitting"
      >
        Close
      </button>
      <button
        type="button"
        class="btn cancel-btn"
        (click)="openRequestEditInfo()"
        [disabled]="submitting"
      >
        Request Edit Info
      </button>
      <button
        type="button"
        class="btn btn-success m-full"
        (click)="approve()"
        [disabled]="submitting"
      >
        Approve
      </button>
    </div>
  }
</div>
